module.exports = __webpack_public_path__ + "static/media/image4.5c1610f9.svg";